import { environment } from '@env/environment';

import { importProvidersFrom } from '@angular/core';

import { provideStore } from '@ngxs/store';
import { NgxsDispatchPluginModule } from '@ngxs-labs/dispatch-decorator';
import { withNgxsReduxDevtoolsPlugin } from '@ngxs/devtools-plugin';
import { withNgxsRouterPlugin, RouterStateSerializer } from '@ngxs/router-plugin';

import { AuthState } from '@shared/states/auth.state';
import { BrowserState } from '@shared/states/browser.state';
import { ActionsState } from '@shared/states/actions.state';
import { DialogState } from '@shared/states/dialog.state';
import { PlanState } from '@shared/states/plan.state';
import { ErrorState } from '@shared/states/error.state';
import { PrefsState } from '@shared/states/prefs.state';
import { SurveyState } from '@shared/states/survey.state';
import { FoldersState } from '@shared/states/folders.state';
import { ReportState } from '@shared/states/report.state';
import { AccountState } from '@shared/states/account.state';
import { BillingState } from '@shared/states/billing.state';
import { CustomRouterStateSerializer } from '@shared/serializers/custom-router-state.serializer';

export const storeProviders = [
  provideStore(
    [
      AuthState,
      BrowserState,
      ActionsState,
      DialogState,
      PlanState,
      ErrorState,
      PrefsState,
      SurveyState,
      FoldersState,
      ReportState,
      AccountState,
      BillingState,
    ],
    {
      developmentMode: !environment.production,
      selectorOptions: {
        suppressErrors: false,
      },
    },
    withNgxsRouterPlugin(),
    withNgxsReduxDevtoolsPlugin({
      disabled: !environment.debug,
      stateSanitizer,
      actionSanitizer,
    }),
  ),
  importProvidersFrom(NgxsDispatchPluginModule.forRoot()),
  {
    provide: RouterStateSerializer,
    useClass: CustomRouterStateSerializer,
  },
];

function stateSanitizer(state: any): any {
  return { ...state /* , templates: null  */ };
}

export function actionSanitizer(action: any): any {
  if (action?.type.startsWith('[Router]')) {
    delete action?.routerState;
    delete action?.event;
  }

  return action;
}
